import { PageLevel, useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React from "react";
import { useHistory } from "react-router";
import { Group } from "types/graphqlapi";
import { listGroupsQuery } from "utils/apis/group";

export const useGroupList = (): [Group[] | undefined, () => void] => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const { setScreenName, setGroup, setPageLevel } = useConsoleState();
  const [groupList, setGroupList] = React.useState<Group[]>();
  const fetchGroups = async () => {
    try {
      const queryResult = await listGroupsQuery();
      setGroupList(queryResult || []);
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
      setLoading(false);
      history.replace("/auth/login");
    }
  };
  React.useEffect(() => {
    setScreenName("グループ管理");
    setPageLevel(PageLevel.groupManagement);
    setGroup("", "");
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [groupList, fetchGroups];
};
